import React from 'react';
import PopularContentItem, {
	PopularContentItemProps,
} from '@components/report/content-items/popular-content-item/PopularContentItem';

import { lackOfPermissionClass } from '@components/report/style.css';

import SnapCarousel from '@shared/snap-carousel/SnapCarousel';

export interface PopularContentProps {
	items?: PopularContentItemProps[];

	isLoading?: boolean;
	isError?: boolean;
	lackOfPermission?: boolean;
}

const PopularContent = ({
	isLoading,
	isError,
	lackOfPermission,
	...props
}: PopularContentProps) => {
	const status = { isLoading, isError, lackOfPermission };
	const available = !isLoading && !isError && !lackOfPermission;
	const items = !available
		? new Array(20).fill({} as PopularContentItemProps)
		: props.items ?? [];

	if (!available || (available && items.length > 0))
		return (
			<SnapCarousel
				className={lackOfPermission ? lackOfPermissionClass : ''}
				items={items?.map((item, idx) => (
					<PopularContentItem key={idx} idx={idx} {...item} {...status} />
				))}
			/>
		);
	else return <></>;
};

export default PopularContent;
